import { render, staticRenderFns } from "./AppointmentManagement.vue?vue&type=template&id=7f0edc70&scoped=true"
import script from "./AppointmentManagement.vue?vue&type=script&lang=js"
export * from "./AppointmentManagement.vue?vue&type=script&lang=js"
import style0 from "./AppointmentManagement.vue?vue&type=style&index=0&id=7f0edc70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0edc70",
  null
  
)

export default component.exports